@switch (loadingStatus$ | async) {
  @case (LoadingStatus.LOADING) {
    <div class="grid-container">
      <div class="grid-item stencil-shimmer"></div>
      <div class="grid-item stencil-shimmer"></div>
      <div class="grid-item stencil-shimmer"></div>
    </div>
  }
  @case (LoadingStatus.OK) {
    @if (fieldHandlers$ | async; as fieldHandlers) {
      <form [formGroup]="formGroup">
        <div class="grid-container">
          @for (handler of fieldHandlers; track handler) {
            <div class="grid-item">
              <aux-renderer-selector [handler]="handler"></aux-renderer-selector>
            </div>
          }
        </div>
      </form>
    }
  }
}
